import {
  deleteBankAccount as doDeleteBankAccount,
  createBankAccount as doCreateBankAccount,
  updateBankAccount as doUpdateBankAccount,
  updateAutoCashout as doUpdateAutoCashout,
} from '@store/login/actions';
import { useDispatch, useSelector } from 'react-redux';

const useBankAccount = () => {
  const dispatch = useDispatch();
  const bankAccount = useSelector((state) =>
    state.login.merchant?.bank_accounts?.find((el) => el.enabled)
  );
  const { banksCodes } = useSelector((state) => state?.common);
  const deleteBankAccount = () => {
    dispatch(doDeleteBankAccount(bankAccount._id));
  };

  // eslint-disable-next-line no-shadow
  const createBankAccount = (bankAccount) => {
    dispatch(doCreateBankAccount(bankAccount));
  };

  // eslint-disable-next-line no-shadow
  const updateBankAccount = (bankAccount) => {
    dispatch(doUpdateBankAccount(bankAccount));
  };

  const updateAutoCashout = () => {
    dispatch(doUpdateAutoCashout());
  };

  return {
    bankAccount,
    banksCodes,
    deleteBankAccount,
    createBankAccount,
    updateBankAccount,
    updateAutoCashout,
  };
};

export default useBankAccount;
